var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('scroll-bar', [_c('el-menu', { attrs: { "mode": "vertical", "unique-opened": "", "default-active": _vm.$route.path, "collapse": _vm.isCollapse, "background-color": "#304156", "text-color": "#fff", "active-text-color": "#409EFF" } }, [_c('sidebar-item', { attrs: { "routes": _vm.permission_routers } })], 1)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };